import { useEffect as e, useRef as t } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useInfiniteScroll.ts
var n = (n) => {
	let r = t(null);
	return e(() => {
		let e = new IntersectionObserver(([e]) => {
			e.isIntersecting && n();
		}, {
			root: null,
			rootMargin: "20px",
			threshold: 0
		});
		return r.current && e.observe(r.current), () => {
			r.current && e.unobserve(r.current);
		};
	}, [n]), r;
};
//#endregion
export { n as useInfiniteScroll };
